<app-not-applicable-label *ngIf="text === ('common.notAvailable' | labelsProvider)" [tooltipDynamicText]="toolTip"> </app-not-applicable-label>

<div *ngIf="text !== ('common.notAvailable' | labelsProvider)">{{ text }}</div>
